import {
  ComponentProps,
  FC,
  PropsWithChildren,
  useContext,
  useRef,
} from 'react';
import { FieldContext } from '../Field/Context';
import Input from '../Input/Input';

export type ColourInputProps = Pick<
  ComponentProps<typeof Input>,
  'value' | 'onChange' | 'onTouch'
>;

export const ColourInput: FC<ColourInputProps> = (props) => {
  const { value, onChange, onTouch } = props;

  const { id, name } = useContext(FieldContext);

  return (
    <input
      name={name}
      id={id}
      value={value}
      onChange={(e) => {
        onChange?.(e?.target.value);
        onTouch?.();
      }}
      type="color"
      className={`h-10 w-14 border  border-solid p-1 block  cursor-pointer rounded-lg border-gray-200  bg-white focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 disabled:pointer-events-none disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900`}
    />
  );
};
